import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  padding: 30px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-size: 1.625rem;
  color: #074f8c;
  @media (max-width: 440px) {
    font-size: 1.1875rem;
  }
`;

export const BackButton = styled.span`
  font-size: 1.25rem;
  color: #074f8c;
  margin-right: 10px;
  margin-left: -3px;
  cursor: pointer;
  @media (max-width: 440px) {
    font-size: 1.125rem;
  }
`;

export const CloseIcon = styled.span`
  font-size: 1.25rem;
  margin-top: -50px;
  margin-right: -11px;
  color: #074f8c;
  cursor: pointer;
  @media (max-width: 440px) {
    font-size: 1.125rem;
  }
`;

export const Content = styled.span`
  font-size: 1.125rem;
  font-weight: 400;
  color: #808495;
  @media (max-width: 440px) {
    font-size: 0.875rem;
  }
`;

export const AdressItem = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AdressLineContainer = styled.div``;

export const AdressLine = styled.span`
  font-size: 1.0625rem;
  color: #074f8c;
  @media (max-width: 991px) {
    font-size: 0.9375rem;
  }
  @media (max-width: 440px) {
    font-size: 0.75rem;
  }
`;

export const AdressName = styled.span`
  font-size: 1.125rem;
  color: #f0b01b;
  @media (max-width: 991px) {
    font-size: 1rem;
  }
  @media (max-width: 440px) {
    font-size: 0.875rem;
  }
`;

export const AdressIcon = styled.span`
  font-size: 1.5625rem;
  color: #f0b01b;
  margin-right: 5px;
  @media (max-width: 991px) {
    font-size: 1.25rem;
  }
  @media (max-width: 440px) {
    font-size: 0.875rem;
  }
`;

export const AdressNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Select = styled.input`
  margin-right: 30px;
  margin-left: 20px;
  @media (max-width: 991px) {
    margin-right: 20px;
    margin-left: 5px;
  }
`;

export const AdressInfoContainer = styled.div``;

export const Hr = styled.hr`
  width: 100%;
  height: 0.5px;
  color: #808495;
  margin-top: 20px;
`;

export const AdressTitleIcon = styled.span`
  font-size: 1.4375rem;
  color: #ffffff;
  margin-bottom: -20px;
  margin-right: 15px;
`;

export const AddressList = styled.div`
  padding: 40px 0px 0px 0px;
  @media (max-width: 440px) {
    padding: 20px 0px 0px 0px;
  }
`;
